export const ACCOUNTS_PARTNER_ID = import.meta.env.VITE_ACCOUNTS_PARTNER_ID;
export const ACCOUNTS_ENV = import.meta.env.VITE_ACCOUNTS_ENV;
export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;
export const ENV = import.meta.env.VITE_ENV;

export const isProductionEnv = ENV === 'production';
export const PENDING_SLA_DAYS = import.meta.env.VITE_PENDING_SLA_DAYS;

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export const COMMIT_ID = import.meta.env.VITE_COMMIT_ID || '';
export const VERSION = import.meta.env.VITE_VERSION || '';
export const BRANCH = import.meta.env.VITE_BRANCH || '';
export const BUILD_ID = import.meta.env.VITE_BUILD_ID || '';
export const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID;
